import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DisclosuresService } from 'src/app/services/disclosures.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { Disclosures } from 'src/app/models/disclosures';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-disclosures',
    templateUrl: './disclosures.component.html',
    styleUrls: ['./disclosures.component.scss'],
    providers: [DisclosuresService],
    imports:[SafePipe,RouterModule]
})
export class DisclosuresComponent implements OnInit {

  title="Investing for Catholics Disclosures and Policies"

  disclosures: Disclosures[]

  constructor(private disclosuresservice: DisclosuresService, private seoservice: SeoService, private meta: Meta, private cdr:ChangeDetectorRef) {

    this.disclosuresservice.getDisclosures().subscribe(resp => {
   
      //removes first article from header
      this.disclosures = resp;
      this.cdr.detectChanges();
   
    })
// $&(this.disclosures)
   }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
    this.meta.addTag({
      name: 'keywords',
      content: 'investing disclosures, investing for catholics disclosures, investing policies'
    });
    this.meta.addTag({
      name: 'description',
      content: 'DISCLOSURES FOR THE HYPOTHETICAL BACKTESTED PERFORMANCE OF THE INVESTING FOR CATHOLICS MODEL INDEX PORTFOLIOS AND INDEXES.'
    });
    this.meta.addTag({
      name: 'author',
      content: 'Investing for Catholics'
    });
    this.meta.addTag({
      name: 'robots',
      content: 'index, follow'
    });
    
  }

}
